<app-merchant-response></app-merchant-response>

<div class="in-alert card-body card rounded-card receiving-information" *ngIf="alertEnabled">
    <div>
              <section class="pymnt_alertinfo_section">
                {{alertText}}
            </section>
        
    </div>
</div>

<div class="order-summary card-body card rounded-card receiving-information">
  <!-- Payment Info Card -->
  <ng-container *ngIf="counter$ | async as left">
    <div class="payment-info-card" *transloco="let t">
      <h2 class="payment-heading">
        <b>{{ t('razorpay.info.header') }}</b>
       <span class = "time-left">Time Left to Pay - {{ formatMMSS(left) }}</span>
      </h2>
      <p class="payment-description">
        {{ t('razorpay.info.text') }}
      </p>
    <button class="btn-continue" (click)="openStatusModal()">
      {{ t('razorpay.btn.text') }}
    </button>
  </div>
</ng-container> 
  

  <!-- MODAL -->
  <ng-template #modalContent let-modal>
    <div class="premium-modal-card">

      <!-- HEADER -->
      <div class="premium-header">
        <span class="premium-title">Select Payment Details</span>
      </div>

      <!-- CONTENT -->
      <div class="premium-modal-content">
        <!-- Amount Display -->
        <div class="amount-display">
          <span class="amount-label">Amount to Pay:</span>
          <span class="amount-value">₹{{ orderData?.amount }}</span>
        </div>

        <!-- CUSTOM RESPONSIVE DROPDOWN -->
        <div class="dropdown-wrapper" (click)="toggleDropdown()">
          <div class="dropdown-display">
            {{ selectedMethod || 'Select Payment Type' }}
          </div>
          <ul class="dropdown-list" *ngIf="dropdownOpen">
            <li
              *ngFor="let m of paymentMethods"
             (click)="selectMethod(m); $event.stopPropagation()"
            >
              <span class="method-icon">{{ m.icon }}</span>
              {{ m.label }}
            </li>
          </ul>
        </div>

        <!-- RADIO OPTIONS -->
        <div *ngIf="selectedMethod" class="simple-radio-group">
          <label class="simple-radio" *ngFor="let opt of stubOptions">
            <input
              type="radio"
              name="status"
              [value]="opt.value"
              [(ngModel)]="stubUserChoice"
            />
            <span class="radio-label">{{ opt.label }}</span>
          </label>
        </div>

        <button
          class="btn-primary premium"
          [disabled]="!selectedMethod || !stubUserChoice"
          (click)="submitStatus()"
        >
          Submit
        </button>
      </div>
    </div>
  </ng-template>
</div>